import { styled } from '@/stitches.config';

import { Box } from '@base-app';
import { ReactComponent as DropdownIcon } from '@assets/icons/dropdown.svg';

export const FlexBoxStyled = styled(Box, {
  alignItems: 'flex-top',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',

  variants: {
    disabled: {
      true: {
        pointerEvents: 'none',
      },
    },
  },
});

export const IconContainerStyled = styled(Box, {
  paddingTop: '$5',
  marginLeft: '-$6',
});

export const DropdownIconStyled = styled(DropdownIcon, {
  height: '$6',
  marginLeft: '$1',
  color: '$darkGray200',
  width: '$6',
  '&:hover': {
    cursor: 'pointer',
  },
});

export const DropdownIconRotatedStyled = styled(DropdownIconStyled, {
  rotate: '180deg',
});
